import { render } from "./ConfigurationCart.vue?vue&type=template&id=6dce6c96"
import script from "./ConfigurationCart.vue?vue&type=script&lang=js"
export * from "./ConfigurationCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__